/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base colors for the Material Dashboard 2 PRO React.
 * You can add new color using this file.
 * You can customized the colors for the entire Material Dashboard 2 PRO React using thie file.
 */

const colors = {
  background: {
    default: "#121212",
    sidenav: "#1e1e1e",
    card: "#1e1e1e",
  },

  text: {
    main: "#ffffff",
    focus: "rgba(255, 255, 255, 0.7)",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#90caf9",
    focus: "#42a5f5",
  },

  secondary: {
    main: "#ce93d8",
    focus: "#ab47bc",
  },

  info: {
    main: "#29b6f6",
    focus: "#0288d1",
  },

  success: {
    main: "#66bb6a",
    focus: "#388e3c",
  },

  warning: {
    main: "#ffa726",
    focus: "#f57c00",
  },

  error: {
    main: "#f44336",
    focus: "#d32f2f",
  },

  light: {
    main: "#f0f2f566",
    focus: "#f0f2f566",
  },

  dark: {
    main: "#ffffff",
    focus: "rgba(255, 255, 255, 0.7)",
  },

  grey: {
    100: "#f8f9fa",
    200: "#f0f2f5",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  gradients: {
    primary: {
      main: "#90caf9",
      state: "#42a5f5",
    },

    secondary: {
      main: "#ce93d8",
      state: "#ab47bc",
    },

    info: {
      main: "#4fc3f7",
      state: "#0288d1",
    },

    success: {
      main: "#66BB6A",
      state: "#43A047",
    },

    warning: {
      main: "#FFA726",
      state: "#FB8C00",
    },

    error: {
      main: "#EF5350",
      state: "#E53935",
    },

    light: {
      main: "#EBEFF4",
      state: "#CED4DA",
    },

    dark: {
      main: "#2a2a2a",
      state: "#121212",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#1e3a5f",
      text: "#90caf9",
    },

    secondary: {
      background: "#424242",
      text: "#ce93d8",
    },

    info: {
      background: "#0d3b66",
      text: "#29b6f6",
    },

    success: {
      background: "#1b3a1b",
      text: "#66bb6a",
    },

    warning: {
      background: "#3e2a00",
      text: "#ffa726",
    },

    error: {
      background: "#3e1010",
      text: "#f44336",
    },

    light: {
      background: "#2a2a2a",
      text: "#e0e0e0",
    },

    dark: {
      background: "#1e1e1e",
      text: "#ffffff",
    },
  },

  coloredShadows: {
    primary: "#90caf9",
    secondary: "#ce93d8",
    info: "#29b6f6",
    success: "#4caf4f",
    warning: "#ff9900",
    error: "#f44336",
    light: "#adb5bd",
    dark: "#404040",
  },

  inputBorderColor: "rgba(255, 255, 255, 0.23)",

  tabs: {
    indicator: { boxShadow: "#666" },
  },
};

export default colors;
